// Статусы участия
export const PARTICIPATION_STATUSES = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  DECLINED: 'declined',
  MAYBE: 'maybe'
};

// Позиции игроков
export const POSITIONS = {
  FORWARD: 'forward',
  DEFENSE: 'defense',
  GOALIE: 'goalie',
  FLEXIBLE: 'flexible'
};

// Цвета для статусов
export const STATUS_COLORS = {
  pending: '#ffa500',
  confirmed: '#28a745',
  declined: '#dc3545',
  maybe: '#17a2b8'
};

// Метки для статусов
export const STATUS_LABELS = {
  pending: 'Ожидает',
  confirmed: 'Подтверждено',
  declined: 'Отклонено',
  maybe: 'Возможно'
};

// Старые константы для совместимости
export const PARTICIPATION_STATUS = {
  NO_STATUS: 0,
  NOT_PARTICIPATING: 1,
  PARTICIPATING: 2
};

export const PARTICIPATION_OPTIONS = [
  { value: PARTICIPATION_STATUS.NO_STATUS, label: 'Без статуса' },
  { value: PARTICIPATION_STATUS.NOT_PARTICIPATING, label: 'Не участвую' },
  { value: PARTICIPATION_STATUS.PARTICIPATING, label: 'Участвую' }
]; 